module.exports = __webpack_public_path__ + "static/img/icon_cloud_p5.730728c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud_p5.jpg
// module id = 4iQv
// module chunks = 21